import React from "react";
import { bindActionCreators } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import categoryActions from "../../../store/actions/products/categories/category.actions";
import useMobileScreen from "../../../hooks/useMobileScreen";
import "./footerComponent.scss";

import logo from "../../../assets/images/logo/logo.svg";
import { useNavigate } from "react-router-dom";

export const FooterComponent = ({ categoryActions }) => {
  const navigate = useNavigate();
  const { isMobileScreen } = useMobileScreen();

  const handleLogoClick = () => {
    navigate("/");
  };
  return (
    <footer className="footerContainer container containerPadd">
      <div className="contentSection">
        <div className="aboutContainer">
          <div className="logoContainer" onClick={handleLogoClick}>
            <img src={logo} alt="Arin Candles Logo" />
          </div>
          {/* <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam quam repellendus porro atque temporibus impedit incidunt perferendis fuga vero labore laborum provident sapiente quaerat similique consectetur, nam enim non iste!</p> */}
        </div>

        <div className="contactContainer">
          <h4>צרו איתנו קשר</h4>
          <div>
            <span>דוא"ל: </span>
            <span>
              <a href="mailto:office@arincandles.com">office@arincandles.com</a>
            </span>
          </div>
          <div>
            <span>וואטסאפ: </span>
            <span>
              <a href="tel:0502215233">050-2215233</a>
            </span>
          </div>

          <div className="deliveryContainer">
            <h4>משלוחים ואיסוף עצמי</h4>
            <p>משלוחים לכל חלקי הארץ (עד חמישה ימי עסקים)</p>
            <p>איסוף עצמי מנס ציונה בתיאום מראש בלבד</p>
          </div>
        </div>
        <div className="serviceTimeContainer">
          <h4>שעות פעילות</h4>
          <span>יום ראשון: 09:00-18:00</span>
          <span>יום שני: 09:00-18:00</span>
          <span>יום שלישי: 09:00-18:00</span>
          <span>יום רביעי: 09:00-18:00</span>
          <span>יום חמישי: 09:00-18:00</span>
        </div>

        <div className="socialMediaContainer">
          <h3>הישארו מחוברים</h3>
          <div className="socialLinksContainer">
            <button>
              <a href="https://www.tiktok.com/@arin_scented_candles" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-tiktok"></i>
              </a>
            </button>
            <button>
              <a href="https://www.instagram.com/arin_scented_candles" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-instagram"></i>
              </a>
            </button>
            <button>
              <a href="https://www.facebook.com/share/1V9PJxJKS1/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-square-facebook"></i>
              </a>
            </button>
          </div>
        </div>
      </div>
      <div className="footerBottom">
        <a href="https://codeil.org/"> Powerd By CODEIL</a>
        <p>&copy; {new Date().getFullYear()} Arin Candles. All rights reserved</p>
      </div>
    </footer>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    categoryActions: bindActionCreators(categoryActions, dispatch),
  };
};

export default connect(null, mapDispatchToProps)(FooterComponent);
